import React, { Component } from 'react';
import styled from 'styled-components';
import VisibilitySensor from 'react-visibility-sensor';
// set multiple refs on the same component/element.
import composeRefs from '@seznam/compose-react-refs';
import { Column } from './layoutUtils';

type Props = {
  children: any;
  className?: string;
  gradientHeight?: number;
  /** Where the fade blends to. Defaults to the theme background - set it when the surface behind differs. */
  gradientColor?: string;
  flex?: boolean;
  passScrollRef?: boolean;
  innerRef?: any;
  style?: any;
};

type State = {
  isEndVisible: boolean;
  containerLoaded: boolean;
};

class ScrollGradient extends Component<Props, State> {
  scrollContainer = React.createRef<HTMLDivElement>();
  readonly state = { isEndVisible: false, containerLoaded: false };

  componentDidMount(): void {
    this.setState({ containerLoaded: !!this.scrollContainer.current });
  }

  render() {
    const { isEndVisible, containerLoaded } = this.state;
    const { children, className, gradientHeight = 30, gradientColor, flex, innerRef, style } = this.props;

    return (
      <Container flex={flex} style={style}>
        <Wrapper ref={composeRefs(this.scrollContainer, innerRef)} className={className}>
          {containerLoaded && (
            <VisibilitySensor
              scrollCheck
              resizeCheck
              containment={this.scrollContainer.current}
              onChange={isEndVisible => this.setState({ isEndVisible })}
              //@ts-ignore
              partialVisibility={'bottom'}
            >
              <div className={'gradient-children-wrapper'}>{children}</div>
            </VisibilitySensor>
          )}
        </Wrapper>
        <Gradient hasGradient={!isEndVisible} gradientHeight={gradientHeight} gradientColor={gradientColor} />
      </Container>
    );
  }
}

export default ScrollGradient;

const Container = styled(Column)<{ flex?: boolean }>`
  overflow: hidden;
  ${props => props.flex && 'flex: 1'};
  width: 100%;
`;

const Gradient = styled.div<{ hasGradient: boolean; gradientHeight: number; gradientColor?: string }>`
  z-index: 1;
  box-shadow: ${props =>
    props.hasGradient ? `0 0 30px ${props.gradientHeight}px ${props.gradientColor || props.theme.background}` : 'none'};
`;

const Wrapper = styled.div`
  overflow: auto;
`;
